import {
  Bot, Mic, Send, Wallet, Layers, TrendingUp, PiggyBank, HandCoins, Umbrella,
  ShieldCheck, EyeOff, Fingerprint, GraduationCap, Baby, HeartHandshake, HeartPulse,
  Accessibility, Languages, Plane, ShoppingBag, Users, Brush, Gamepad2, Briefcase,
  Code2, Microscope, Leaf, ListChecks, BadgeCheck, Cpu, PawPrint, Mountain,
  Sparkles, Link as LinkIcon,
} from "lucide-react";

export const TAG_ICON = {
  "#Agents": Bot, "#Voice": Mic, "#Payments": Send, "#Wallet": Wallet, "#DeFi": Layers,
  "#Investing": TrendingUp, "#Finance": PiggyBank, "#Lending": HandCoins, "#Insurance": Umbrella,
  "#Security": ShieldCheck, "#Privacy": EyeOff, "#Identity": Fingerprint, "#Education": GraduationCap,
  "#Kids": Baby, "#Seniors": HeartHandshake, "#Health": HeartPulse, "#Accessibility": Accessibility,
  "#Translation": Languages, "#Travel": Plane, "#Commerce": ShoppingBag, "#Social": Users,
  "#Creators": Brush, "#Gaming": Gamepad2, "#Enterprise": Briefcase, "#DevTools": Code2,
  "#Research": Microscope, "#Sustainability": Leaf, "#Productivity": ListChecks, "#Careers": BadgeCheck,
  "#IoT": Cpu, "#Pets": PawPrint, "#Avalanche": Mountain, "#U-Bot": Bot, "#U-Topia": Sparkles,
  "#AI": Sparkles, "#Web3": LinkIcon,
};

export const ECOSYSTEM = ["#U-Bot", "#U-Topia", "#Avalanche"];
export const TRACK_TAGS = ["#AI", "#Web3"];

export function isEcosystem(tag) {
  return ECOSYSTEM.includes(tag);
}

// gradient pair from slug hash
const GRAD = ["#7C5CFF", "#38BDF8", "#FF5FA2", "#2ED3A0", "#E2C46A"];
export function heroGradient(slug) {
  let h = 0;
  for (let i = 0; i < slug.length; i++) h = (h * 31 + slug.charCodeAt(i)) >>> 0;
  const a = GRAD[h % GRAD.length];
  const b = GRAD[(h >> 3) % GRAD.length];
  const c = a === b ? GRAD[(h >> 6) % GRAD.length] : b;
  return `linear-gradient(135deg, ${a} 0%, ${c} 100%)`;
}

// first topic tag for icon (skip track + ecosystem)
export function firstTopicTag(u_tags = []) {
  return u_tags.find((t) => !TRACK_TAGS.includes(t) && !ECOSYSTEM.includes(t)) || "#Agents";
}

export function cardTags(u_tags = []) {
  const filtered = u_tags.filter((t) => !TRACK_TAGS.includes(t));
  const eco = filtered.filter((t) => ECOSYSTEM.includes(t));
  const rest = filtered.filter((t) => !ECOSYSTEM.includes(t));
  return [...eco, ...rest];
}

export function trackBadge(track) {
  if (track === "AI, Web3") return "AI + Web3";
  return track;
}

export function initials(name) {
  return (name || "")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "U";
}
